import { AnswerSideBarItem } from "@/stores/answer-side-bar";
import { Text } from "../ui/text";
import { Link } from "react-router-dom";
import PdfIcon from "../ui/icons/PdfIcon";

const AnswerSourceItem = ({ item, index }: { item: AnswerSideBarItem; index?: number }) => {
  //title이 pdf로 끝나느 경우 PDF 변수 True, url 공백 처리
  const isPdf = item.title?.toLowerCase().endsWith(".pdf");
  const safeUrl = item.url?.trim() ?? "";

  // URL에서 도메인 추출
  const getFaviconUrl = (url: string) => {
    try {
      const domain = new URL(url).hostname;
      return `https://www.google.com/s2/favicons?domain=${domain}&sz=16`;
      // sz=64는 크기 (16, 32, 64, 128 등 가능)
    } catch {
      return "/images/answer_source_icon.svg"; // 기본 아이콘
    }
  };

  const getHostname = (url: string) => {
    try {
      return new URL(url).hostname;
    } catch {
      return "";
    }
  };

  const content = (
    <>
      <div className="flex gap-[4px] items-center">
        {index !== undefined && (
          <Text variant="label-lg" className="text-grey-0 shrink-0 text-[14px]">[{index}]</Text>
        )}
        {/* PDF 제목이면 favicon 대신 PDF 아이콘을 표시 */}
        {isPdf ? (
          <div className="w-[24px] h-[24px] rounded-lg flex justify-center items-center bg-red-30 shrink-0">
            <PdfIcon />
          </div>
        ) : (
          <img
            src={getFaviconUrl(safeUrl)}
            alt="answer-source"
            className="rounded-full"
          />
        )}
        <Text variant="body-regular">{isPdf ? item.title : getHostname(safeUrl)}</Text>
      </div>

      {!isPdf && (
        <Text variant="label-lg" className="text-grey-20 line-clamp-2">
          {item.title}
        </Text>
      )}
      <Text variant="body-light" className="text-grey-50 line-clamp-2">
        {item.content}
      </Text>
    </>
  );

  return (
    <article className="hover:bg-gray-50">
      {/* URL이 없으면 Link 대신 일반 컨테이너로 렌더링 */}
      {safeUrl ? (
        <Link
          className="flex flex-col gap-1 cursor-pointer  p-2 rounded-lg"
          to={safeUrl}
          target="_blank"
        >
          {content}
        </Link>
      ) : (
        <div className="flex flex-col gap-1 p-2 rounded-lg">
          {content}
        </div>
      )}
    </article>
  );
};

export default AnswerSourceItem;
